import 'scss/form/component/datetime_picker.scss';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import moment from 'moment';
import classNames from 'classnames';
import LaddaButton from 'react-ladda';
import {submitForm} from 'js/common/url_helper';
import {FormDatetimePicker, FormCheckbox} from 'js/form_components/';
import t from 'tcomb-form';

const {Form} = t.form;

export default class CreateFlight extends Component {
    static propTypes = {
        urls: PropTypes.shape({
            createFlightUrl: PropTypes.string.isRequired
        }).isRequired,
        campaign: PropTypes.shape({
            id: PropTypes.number.isRequired
        }).isRequired,
        constants: PropTypes.shape({
            payoutPercentage: PropTypes.number.isRequired
        }).isRequired
    };

    constructor(props) {
        super(props);
        const {payoutPercentage} = this.props.constants;
        const {id: campaign_id} = this.props.campaign;
        this.state = {
            campaign_id,
            start_date_unix: null,
            end_date_unix: null,
            label: 'Default Flight Label',
            revenue_share: payoutPercentage,
            fill_from_hopper: false,
            target_new: 0,
            target_reactivated: 0
        };
    }

    handleFormSubmit = e => {
        e.preventDefault();
        const {createFlightUrl} = this.props.urls;

        if (this.refs.form.getValue()) {
            const postBody = R.pick(
                [
                    'campaign_id',
                    'start_date_unix',
                    'end_date_unix',
                    'label',
                    'revenue_share',
                    'fill_from_hopper',
                    'target_new',
                    'target_reactivated'
                ],
                R.evolve(
                    {
                        target_new: Number,
                        target_reactivated: Number
                    },
                    this.state
                )
            );

            submitForm('POST', createFlightUrl, postBody);
        }
    };

    isValid(formData) {
        formData = formData || this.state;
        const formType = this.getFormType();
        const result = t.validate(formData, formType);
        return result.isValid();
    }

    getFormType() {
        return t.struct({
            start_date_unix: t.Number,
            end_date_unix: t.Number,
            label: t.String,
            revenue_share: t.Number,
            fill_from_hopper: t.maybe(t.Boolean),
            target_new: t.maybe(t.Number),
            target_reactivated: t.maybe(t.Number)
        });
    }

    getFormOptions() {
        const formData = this.state;
        const {campaign} = this.props;

        const selectedStartDate = moment(formData.start_date_unix * 1000);
        const selectedEndDate = moment(formData.end_date_unix * 1000);

        const flightStart = moment(campaign.flight_start);
        const flightEnd = moment(campaign.flight_end);

        const minStartDate = flightStart;
        const maxStartDate = selectedEndDate.isValid() ? selectedEndDate : flightEnd;

        const minEndDate = selectedStartDate.isValid() ? selectedStartDate : flightStart;
        const maxEndDate = flightEnd;

        return {
            template(locals) {
                const isFillFromHopperActive = locals.value.fill_from_hopper;

                return (
                    <div>
                        <div className="create-flight-form">
                            {locals.inputs.start_date_unix}
                            {locals.inputs.end_date_unix}
                            {locals.inputs.label}
                            {locals.inputs.revenue_share}
                        </div>
                        <div className="create-flight-form">
                            {locals.inputs.fill_from_hopper}
                            {isFillFromHopperActive ? locals.inputs.target_new : null}
                            {isFillFromHopperActive ? locals.inputs.target_reactivated : null}
                        </div>
                    </div>
                );
            },
            fields: {
                start_date_unix: {
                    label: 'Start Date',
                    factory: FormDatetimePicker,
                    minDate: minStartDate,
                    maxDate: maxStartDate,
                    defaultValue: moment()
                        .hour(20)
                        .minute(0)
                        .second(0)
                },
                end_date_unix: {
                    label: 'End Date',
                    factory: FormDatetimePicker,
                    minDate: minEndDate,
                    maxDate: maxEndDate
                },
                revenue_share: {
                    label: 'Revenue Share'
                },
                fill_from_hopper: {
                    label: 'Fill From Hopper',
                    factory: FormCheckbox
                },
                target_new: {
                    label: 'Target New'
                },
                target_reactivated: {
                    label: 'Target Reactivated'
                }
            }
        };
    }

    handleFormChange = formData => {
        this.setState(R.merge(this.state, formData));
    };

    render() {
        const formData = this.state;
        const formType = this.getFormType();
        const formOptions = this.getFormOptions();
        return (
            <div>
                <form onSubmit={this.handleFormSubmit}>
                    <Form
                        ref="form"
                        type={formType}
                        value={formData}
                        options={formOptions}
                        onChange={this.handleFormChange}
                    />

                    <div className="btn-container">
                        <LaddaButton
                            loading={false}
                            progress={0}
                            buttonStyle="zoom-in"
                            spinnerSize={30}
                            spinnerColor="black"
                            className={classNames('btn', 'btn-success', 'btn-big', 'btn-submit')}
                            type="submit"
                        >
                            Create Flight
                        </LaddaButton>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./invite_flights/create_flight.js